import { NgModule } from '@angular/core';
import { FilterPipe } from './filter.pipe';
import { DaysSincePipe } from './daysSince.pipe';
import { CsvTagsPipe } from './csvTags.pipe';

@NgModule({
  declarations: [FilterPipe, DaysSincePipe, CsvTagsPipe],
  imports: [],
  exports: [FilterPipe, DaysSincePipe, CsvTagsPipe],
  providers: []
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts